import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findTemplates = createAsyncThunk(
  "templateList/find",
  async (data, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    let templateList = state.templateList.templates;
    //Filtra por perfil
    templateList = state.templateList.templates.filter(
      (item) => item.sourceOrganization?.id == state.userAuthentication.user?.sourceOrganization
    );
    let maxUpdate: number = 0;
    if (templateList.length > 0) {
      const orderedList = [...templateList].sort((a, b) => {
        if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      if (orderedList[orderedList.length - 1].updatedAt! > 0) {
        maxUpdate = orderedList[orderedList.length - 1].updatedAt!;
      }
    }
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}form`, {
        params: {
          where: {
            assignedTo: "",
            updatedAt: { ">": maxUpdate },
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
          limit: -1,
        },
      });
      let newList = [...templateList];

      data.forEach((element: any) => {
        if (newList.find((el) => el.id === element.id)) {
          let template = newList.find((el) => el.id === element.id);
          const indexToUpdate = newList.indexOf(template!);
          newList.splice(indexToUpdate, 1);
          newList.push(element);
        } else {
          newList.push(element);
        }
      });
      return newList;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
